import * as React from "react";
import _ from "lodash";
import { Fragment } from "react";
import {
  IFilterData,
  BaseListComponentState,
} from "../../components/BaseListComponent";
import {
  createFilterData,
  mapEntityList,
} from "../../services/utility/autoMapperService";
import BaseListComponent from "../../components/BaseListComponent";
import ItemsTable, {
  filterFieldData,
} from "../../components/tableComponents/itemsTable";
import TableFilterPane from "../../components/tableComponents/tableFilterPane";
import settlementPayoutAndCollectionReport from "../../services/report/settlementPayoutAndCollectionReportService";

export interface AppzoneSettlementAndPaymentReportProps { }

export interface AppzoneSettlementAndPaymentReportState
  extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
}

class AppzoneSettlementAndPaymentReportList extends BaseListComponent<AppzoneSettlementAndPaymentReportState> { }

class AppzoneSettlementAndPaymentReport extends React.Component<
  AppzoneSettlementAndPaymentReportProps,
  AppzoneSettlementAndPaymentReportState
> {
  constructor(props: AppzoneSettlementAndPaymentReportProps) {
    super(props);
    this.state = {
      data: createFilterData([
        // "sweepEpisodeId",
        "lenderInstitutionCode",
        "lenderInstitutionName",
        "debitedInstitution",
        "thirdPartySweepChannel"
      ]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [
        // { name: "sweepEpisodeId", fieldType: "text", value: "" },
        { name: "lenderInstitutionCode", fieldType: "text", value: "" },
        { name: "lenderInstitutionName", fieldType: "text", value: "" },
        { name: "debitedInstitution", fieldType: "text", value: "" },
        {
          name: "thirdPartySweepChannel",
          fieldType: "select",
          options: [
            "Recova",
            "Paystack"
          ],
          value: ""
        }
      ],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
    };
  }

  handlePageChange = async (currentPage: number, pageSize: number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    data = typeof data === "undefined" ? this.state.data : data;
    var dataFilter = this.getFilteredItems(data)
    this.setState({ fetching: true });
    try {
      const reportItems = await settlementPayoutAndCollectionReport.filterAppzoneSettlementAndPayoutReport(
        pageSize,
        currentPage,
        dataFilter
      );
      this.setState({
        tableItems: mapEntityList({
          entityList: reportItems.data.data,
          properties: [
            { oldName: "debitedInstitution", newName: "debitedInstitution" },
            { oldName: "totalAmountAttempted", newName: "totalAmountAttempted" },
            { oldName: "totalAmountDebited", newName: "totalAmountDebited" },
            { oldName: "settlementDateTime", newName: "settlementDateTime" },
            { oldName: "settlementAmount", newName: "settlementAmount" },
            { oldName: "settlementAccount", newName: "settlementAccount" },
            { oldName: "settlementTransactionRef", newName: "settlementTransactionRef" },
            {
              isTag: true,
              oldName: "settlementStatus",
              newName: "settlementStatus",
              primary: "PushedForManualSettlement",
              secondary: "PushedAndAwaitingResponse",
              success: "Successful",
              danger: "Failed",
              warning: "Pending"
            },
            { oldName: "narration", newName: "narration" },
            { oldName: "sweepEpisodeId", newName: "sweepEpisodeId" },
            {
              isTag: true,
              oldName: "thirdPartySweepChannel",
              newName: "thirdPartySweepChannel",
              success: "Recova",
              primary: "Paystack"
            },
          ],
        }),
        currentPage,
        pageSize,
        totalSize: reportItems.data.totalCount,
        fetching: false,
      });
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
      } else {
      }
    } finally {
      this.setState({ fetching: false });
    }
  };

  handleOnExport = async (type: string) => { };

  fetchItemById = async (item: any) => { };

  getFilteredItems = (data: IFilterData) => {
    let filteredItems = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key].item2;
      }
    });
    return filteredItems;
  };

  getFilteredItemsText = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
  }

  render() {
    const {
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>Settlement And Payment Report</b>
              </h3>
            </div>
            <AppzoneSettlementAndPaymentReportList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              initialValues={{
                data: createFilterData([
                  // "sweepEpisodeId",
                  "lenderInstitutionCode",
                  "lenderInstitutionName",
                  "debitedInstitution",
                  "thirdPartySweepChannel"
                ]) as IFilterData,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: [
                  // { name: "sweepEpisodeId", fieldType: "text", value: "" },
                  { name: "lenderInstitutionCode", fieldType: "text", value: "" },
                  { name: "lenderInstitutionName", fieldType: "text", value: "" },
                  { name: "debitedInstitution", fieldType: "text", value: "" },
                  {
                    name: "thirdPartySweepChannel",
                    fieldType: "select",
                    options: [
                      "Recova",
                      "Paystack"
                    ],
                    value: ""
                  }
                ],
                item: {},
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({ }) => (<></>)}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItemsText(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="SettlementAndPaymentReport"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                              amountColumn={["totalAmountAttempted", "totalAmountDebited", "settlementAmount"]}
                              amountInNaira={true}
                              timeColumn={["settlementDateTime"]}
                              disableViewDetails={true}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></AppzoneSettlementAndPaymentReportList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default AppzoneSettlementAndPaymentReport;
